module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlwAAAAGCAYAAAAWlkAIAAAAjElEQVRoQ+3WMRGAQAwEQOKJEguoxQIlnsABZeYmv28gyd4XV/t9vZtHgMCSAs9x1pKHO5oAAQLNAqVwNYsbRyBIQOEKCsMqBAiMFlC4RsfrOAL/AgqXH0KAAIEeAYWrx9kUApECCldkLJYiQGCggMI1MFQnESBAgAABAlkCCldWHrYhQIAAAQIEBgp8z2kVW61nizQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_line2.png
// module id = 3biT
// module chunks = 5